import request from "@/utils/axios";

//  网站SAAS-获取热门行业列表
export function INDUSTRYSHOT(data) {
  return request({
    url: '/api//api/industrybrand/industrysHot',
    method: 'get',
    data
  })
}
//  搜索行业/品牌(全检)
export function CHECKALLINDUSTRYBRAND(data) {
  return request({
    url: '/api/industrybrand/checkAllIndustryBrand',
    method: 'POST',
    data
  })
}
//  网站SAAS-获取热门行业列表
export function QUERYMAINPERMIT(data) {
  return request({
    url: '/api/users/queryMainPermit',
    method: 'get',
    data
  })
}